import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react'
import {SettingItemStyled} from "./styled";

export const ItemTitleStyled = styled.div`
  text-transform: uppercase;
  flex: 30%;
`;

export const ItemValueStyled = styled.div`
  flex:60%;
`;

const BoolItem = props => {
  const { ItemTitle, ItemValue, onChangeFunction, disabled } = props;

  return (
      <SettingItemStyled>

        <ItemTitleStyled>
          <label>
            {ItemTitle} :
          </label>
        </ItemTitleStyled>

        <ItemValueStyled>
          <Checkbox
              disabled={disabled}
              checked={ItemValue}
              onChange={onChangeFunction}
          />
        </ItemValueStyled>

      </SettingItemStyled>
  );
};

export default BoolItem;

BoolItem.propTypes = {
  ItemTitle: PropTypes.string,
  ItemValue: PropTypes.bool,
  onChangeFunction: PropTypes.any,
};

BoolItem.default = {
  ItemTitle: '-',
  ItemValue: false,
  onChangeFunction: null
};
